import React, { Component } from 'react'
import Modal, { IModalProps } from '../../components/html/Modal'
import Input from "../../components/html/Input";
import Button from "../../components/html/Button";
import { ThemeProps } from "../../components/styles/themeprops";
import './cookiemodal.css';
import ModalBox from '../../components/html/Modal';
import { Trans, useTranslation } from "react-i18next";
import {Helpers} from '../misc/Helpers';
import { patiApi } from '../../components/misc/PatiApi'
import {handleLogError} from "../../components/misc/Helpers";

type Props = { theme: ThemeProps, open: boolean, onClose: () => void, }
export default function CookieModal({ theme, open, onClose }: Props) {
	let cc_id:string="";
	const { t, i18n } = useTranslation();
	async function hideCookieConsent(event:React.MouseEvent) {
	}
	function showSettings(){
		document.getElementById("cc_dialog_0")!.style.display="none";
		document.getElementById("cc_dialog_1")!.style.display="block";
	}
	function hideSettings(){
		document.getElementById("cc_dialog_1")!.style.display="none";
		document.getElementById("cc_dialog_0")!.style.display="block";
	}
		
	function acceptAll(){
		setCookie("11");
	}
	
	function accept(){
		const checkboxes = 	document.querySelectorAll('#cc_dialog_1 input[type=checkbox]');
		let cc_settings:string="";
		for (var i = 0; i < checkboxes.length; i++) {
			cc_settings += (checkboxes[i] as any).checked?'1':'0';
		}
		setCookie(cc_settings);
	}
	
	function setCookie(ccSettings:string){
		var cc_cookie = document.cookie.match(Helpers.CC_REGEXP);				
		if (cc_cookie) {
			patiApi.consentReject(cc_cookie[2],parseInt(cc_cookie[1])).then(response => { // 
				}).catch(error => {handleLogError(error)})
		}

		var cc_now = (Date.now()/1000).toFixed();
		var duration = (ccSettings.indexOf("0") === -1) ? 90 : 1;
		const cc_expires = new Date(Date.now() + duration*24*60*60*1000);

		document.cookie = 'cc'+ '=' + cc_now + '-' + document.getElementById('cc_id')!.innerText + '-' + ccSettings + ';expires=' + cc_expires.toUTCString() + ';path=/';
		
		patiApi.consentAdd(cc_id,ccSettings, duration,cc_expires.getTime()).then(response => { // 
				}).catch(error => {handleLogError(error)})
				
		onClose();
	}
	
	async function onShow(){
		const cc_cookie = document.cookie.match(Helpers.CC_REGEXP);
		if (cc_cookie) {
				cc_id = cc_cookie[2];
		}else{
			if (window.crypto && window.crypto.randomUUID) {
					cc_id = window.crypto.randomUUID().replaceAll('-','').substring(0, 16);
				} else {
					cc_id = Math.random().toString(16).substring(2, 10) + Math.random().toString(16).substring(2, 10);
				}
		}
		const ccId = document.getElementById('cc_id');
		if(ccId){
			ccId.innerText=cc_id;	
		}
	}
	return (
		<div>
			<ModalBox onShow={onShow} open={open} onClose={onClose} title={t('consent.header')} className="cookieModal" closeButton={false} backdrop="static" keyboard={false}>
				<div className="form-container ccdialoug">

					<div id="cc_banner" className="cc_banner">

						<p className="cc_p">
							<Trans i18nKey="consent.content.description">
					      Wir setzen Cookies ein, um unsere Webseiten optimal für Sie zu gestalten und unsere Plattform für Sie zu verbessern. In den <b>Einstellungen</b> können Sie auswählen, welche Cookies Sie zulassen wollen. Weitere Infos sowie die Möglichkeit Ihre Auswahl jederzeit zu ändern und erteilte Einwilligungen zu widerrufen finden Sie in den <a className="cclink" href='/Service/cookie-policy'>\u00BB Cppkie-Richtlinie</a>.
					    </Trans>
							
						</p>
						<div id="cc_dialog_0">
							<p className="cc_p">
								<Trans i18nKey="consent.content.allAccept">
					      Mit einem Klick auf <b>Bestätigen</b> akzeptieren Sie diese Verarbeitung.
					    	</Trans>
					    
							</p>
							<div className="cc_commands" style={{ textAlign: "right" }}>
								<Button type="button" className="btn-lg" onClick={showSettings} buttonClass="primary">
									{t('consent.button.edit')}
				        </Button>
		  					<Button type="button" className="btn-lg" buttonClass='secondary' onClick={acceptAll}>
										{t('consent.button.allAccept')}
								</Button>
							
							</div>
						</div>
						<div id="cc_dialog_1" className="cc_dialog_1">
							<p className="cc_p">
								<Trans i18nKey="consent.content.dialog1.description">
					      Mit einem Klick auf <b>Alle akzeptieren</b> akzeptieren Sie diese Verarbeitung.
					    	</Trans>
							</p>

							<div className="cc_options row">
								<div className="form-check col-sm-6 cc_checkbox_div">
									<input type="checkbox" checked disabled className="cc_checkbox" />
									<label className="cc_checkbox_label_1">{t('consent.checkbox.tn')}</label>
								</div>
								<div className="form-check col-sm-6" style={{ position: "relative", display: "block", paddingLeft: "1.25rem", fontSize: "1rem" }}>
									<input type="checkbox" className="cc_checkbox" />
									<label className="cc_checkbox_label_2">{t('consent.checkbox.stats')}</label>
								</div>
							</div>
							<div className="cc_commands" style={{ textAlign: "right" }}>
								<Button type="button" className="btn-lg" onClick={hideSettings} buttonClass="primary">
									{t('consent.button.back')}
				        </Button>
		  					<Button type="button" className="btn-lg" buttonClass='secondary' onClick={accept}>
									{t('consent.button.accept')}
								</Button>
							</div>
						</div>
						<div className="float-left">Cookie-ID: <span className="cc_id" id="cc_id" style={{ fontStyle: "italic" }}></span></div>
						<div className="float-right"><a className="cc_imprint" href="/Service/impressum" onClick={hideCookieConsent}>» {t('imprint')}</a></div>
					</div>




				</div>
			</ModalBox>
		</div>
	)

}